/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { useState, Fragment } from 'react';
import { Button, Tooltip, TooltipProps } from 'reactstrap';

type Text = string | JSX.Element;

const renderComponent = (Component: JSX.Element | undefined, id: string, text?: Text) => {
  if (Component) {
    // eslint-disable-next-line react/jsx-pascal-case
    return <Component.type {...Component.props} id={id} />
  }

  return <Button className='mr-1' color='secondary' id={id}>
    {text}
  </Button>
};

type SimpleTooltipProps = Omit<TooltipProps, 'target'>

interface Props extends SimpleTooltipProps {
  component?: JSX.Element | undefined;
  children?: JSX.Element | (JSX.Element | undefined | boolean)[] | string;
  text?: Text;
  popupClassName?: string;
}

export const SimpleTooltip = (props: Props) => {
  const { text, component, children, delay, trigger = 'hover', ...rest } = props;

  const [stateId] = useState(Math.random().toString(36).substr(2, 9));
  const [isOpen, setOpen] = useState(false);
  const defaultDelay = delay || { show: 200, hide: 0 };

  const tooltipId = 'Tooltip-' + stateId;
  const toggle = () => setOpen(!isOpen);

  return (
    <Fragment>
      {component && renderComponent(component, tooltipId, text)}
      {children && <span id={tooltipId} className={props.className}>{children}</span>}
      {text && <Tooltip
        {...rest}
        className={`${props.popupClassName} weglot-translate`}
        isOpen={isOpen}
        trigger={trigger}
        target={tooltipId}
        delay={defaultDelay}
        toggle={toggle}
        >
        {text}
      </Tooltip>
      }
    </Fragment>
  );
}
export default SimpleTooltip;
